export default __webpack_public_path__ + "static/media/logo2.8ce4ae83.PNG";